/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs */

const en_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response latency`)
};

const ar_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمن الاستجابة`)
};

const bn_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেসপন্স ল্যাটেন্সি`)
};

const de_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwortlatenz`)
};

const es_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latencia de respuesta`)
};

const fr_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latence de réponse`)
};

const pt_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latência de resposta`)
};

const zh_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应延迟`)
};

const tr_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yanıt gecikmesi`)
};

const ru_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задержка ответа`)
};

const pl_svc_ai_agent_development_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opóźnienie odpowiedzi`)
};

/**
* | output |
* | --- |
* | "Response latency" |
*
* @param {Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_work_0_metric_1_label = /** @type {((inputs?: Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Work_0_Metric_1_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "de") return de_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "es") return es_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_work_0_metric_1_label(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_work_0_metric_1_label(inputs)
	return en_svc_ai_agent_development_work_0_metric_1_label(inputs)
});
export { svc_ai_agent_development_work_0_metric_1_label as "svc_ai-agent-development_work_0_metric_1_label" }